<script>
    export let title;
    export let bg;
</script>

<div class="bg-white relative">
    {#if bg !== undefined}
        <video autoplay loop muted class="w-full aspect-auto">
            <source 
                src="{bg}_hevc_720.mp4"
                media="(min-width: 768px)"
                type="video/mp4; codecs=hevc" 
            />
            <source 
                src="{bg}_hevc_360.mp4"
                media="(max-width: 768px)"
                type="video/mp4; codecs=hevc" 
            />
            <source 
                src="{bg}_avc_720.mp4"
                media="(min-width: 768px)"
                type="video/mp4; codecs=avc1" 
            />
            <source 
                src="{bg}_avc_360.mp4"
                media="(max-width: 768px)"
                type="video/mp4; codecs=avc1" 
            />
            <source 
                src="{bg}_AV1_720.webm"
                media="(min-width: 768px)"
                type="video/webm; codecs=av1"
            />
            <source 
                src="{bg}_AV1_360.webm"
                media="(max-width: 768px)"
                type="video/webm; codecs=av1"
            />
            <source 
                src="{bg}_VP9_720.webm"
                media="(min-width: 768px)"
                type="video/webm; codecs=vp9"
            />
            <source 
                src="{bg}_VP9_360.webm"
                media="(max-width: 768px)"
                type="video/webm; codecs=vp9"
            />
        </video>
        <div class="absolute grid grid-cols-1 content-center h-full w-full top-0 left-0">
            <div class="text-zinc-50 text-4xl md:text-6xl text-center content-center">{@html title}</div>
        </div>
    {:else}
        <div class="bg-white">
            <div class="container mx-auto py-60 md:py-96 px-2 text-zinc-900 text-4xl md:text-6xl text-center">{@html title}</div>
        </div>
    {/if}
</div>
